var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_vm._t("default")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }